var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnneagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.96 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #6533e9;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.48,
    cy: 29.27,
    r: 8.93,
    transform: "translate(-5.8 51.2) rotate(-76.67)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "23.74 18.81 23.74 10.51 19.69 10.51 29.49 .75 39.27 10.51 35.22 10.51 35.22 18.81"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "39.76 23.24 46.45 16.55 43.38 13.49 58.2 13.51 58.21 28.32 55.14 25.26 42.15 38.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.49,53.69v5.06H11.47v-5.06c0-3.99,1.52-7.62,3.97-10.36,2.84-3.15,6.96-5.13,11.54-5.13h5c4.57,0,8.69,1.99,11.54,5.13,2.46,2.74,3.97,6.38,3.97,10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.49,58.75v-5.06c0-3.99-1.52-7.62-3.97-10.36"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "16.82 38.26 3.82 25.26 .75 28.32 .76 13.51 15.58 13.49 12.51 16.55 19.2 23.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnneagram);
export default __webpack_public_path__ + "static/media/enneagram.98f8e10df1b1f36485f6798ed5a01a60.svg";
export { ForwardRef as ReactComponent };